export default __webpack_public_path__ + "static/media/display3.9bc9f441.png";